// import stringify from 'json-stringify-safe';
// Local storage functions used to load state from local storage and
// save state to local storage.

// Note that serialization of javascript objects has some limitations
// For example, Date objects are serialized to ISO-formatted date
// strings, but JSON.parse() leaves these in string form and does not
// restore the original date object. Be sure to do proper conversion
// as needed.

let compName = 'localStorage';
// trace functions

// Function to load state. This function is using the localStorage
// key of 'state'. 
export const loadState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.log(err);
    }
};

// Function to save state. This function is using the localStorage
// key of 'state' to save the redux state. Note, that state object passed in
// should reflect the state of your combined reducers.
export const saveState = (state) => {
    try  {  
        // console.log("In saveState; getting ready to stringify state; this is state before stringify");
        // console.log(state);
        const serializedState = JSON.stringify(state);
        // console.log("This is the state before save");
        // console.log(state);
        // const serializedState = JSON.stringify(state.auth);
        // const serializedState = JSON.stringify(state.items);
        localStorage.setItem('state', serializedState);
    } catch (err) {
        console.log(err);
    }
}




// WEBPACK FOOTER //
// ./src/store/localStorage.js